import React, { useState } from 'react'
import { IonList } from '@ionic/react'
import { Form, Formik } from 'formik'
import { SubmitButton, FormWideErrorReporter } from 'formik-components'
import { QuestionFields } from '../components'
import { questionValidationSchema } from 'utils'
import { uniq } from 'lodash'
import PropTypes from 'prop-types'
import * as Yup from 'yup'

const propTypes = {
  questions: PropTypes.array,
  initialValues: PropTypes.object.isRequired,
  onSubmit: PropTypes.func.isRequired,
}
const defaultProps = {
  questions: [],
}

function QuestionnaireForm({ initialValues, questions, onSubmit }) {
  const [formKeysSkipValidation, setFormKeysSkipValidation] = useState([])

  const [customFormWideError, setCustomFormWideError] = useState(null)

  const handlePhotoUploadAttempt = (fieldName) => {
    setFormKeysSkipValidation(uniq([...formKeysSkipValidation, fieldName]))
  }

  const validationSchema = Yup.object(
    questionValidationSchema(questions, formKeysSkipValidation)
  )

  return (
    <Formik
      initialValues={initialValues}
      validationSchema={validationSchema}
      onSubmit={onSubmit}
      validateOnBlur={false}
    >
      {({ isSubmitting, setFieldError }) => {
        return (
          <Form>
            <FormWideErrorReporter
              key={customFormWideError}
              customFormWideError={customFormWideError}
              setCustomFormWideError={setCustomFormWideError}
            />
            <IonList>
              <QuestionFields
                questions={questions}
                isSubmitting={isSubmitting}
                onPhotoUploadAttempt={handlePhotoUploadAttempt}
                setCustomFormWideError={setCustomFormWideError}
                setFieldError={setFieldError}
              />
              <SubmitButton isSubmitting={isSubmitting}>Continue</SubmitButton>
            </IonList>
          </Form>
        )
      }}
    </Formik>
  )
}

QuestionnaireForm.propTypes = propTypes
QuestionnaireForm.defaultProps = defaultProps

export default React.memo(QuestionnaireForm)
